import { INSPECT_TYPE } from "@/model/InspectType";
import { GenshaInspectionSelectionsRouteService } from "@/model/GenshaInspectionSelectionsRouteService";
import {
  createBaseInspectionSelectionsRouteService
} from "@/service/InspectionSelectionsRouteService";
import requestService from "@/service/requestService";

/*
 * WHY: gensha 固有の API、inspectType、headerTopic、disabledSave 除外条件を
 * inspectionSelections.vue の routeName 分岐から分離する。
 */
export function createGenshaInspectionSelectionsRouteService(
  reqService: requestService
): GenshaInspectionSelectionsRouteService {
  return createBaseInspectionSelectionsRouteService({
    routeName: "gensha",
    inspectType: INSPECT_TYPE.GENSHA,
    headerTopic: "現車チェック内容",
    apiPath: "gensha",
    reqService,
    getInspect: (uketsukeExtendsId: number) =>
      reqService.getGenshaInspect(uketsukeExtendsId),
    getInspectByCategoryId: (
      uketsukeExtendsId: number,
      sknInspectCategoryId: number
    ) =>
      reqService.getGenshaInspectByCategoryId(
        uketsukeExtendsId,
        sknInspectCategoryId
      ),
    saveInspect: (data: any) => reqService.saveGenshaInspect(data),
    /*
     * WHY: gensha/legal56 では未紐づけの disabledSave 整備を保存対象から外すため。
     */
    shouldRemoveUnlinkedDisabledSaveSeibi(): boolean {
      return true;
    }
  });
}
